import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=499a8808&"
import script from "./Attachments.vue?vue&type=script&lang=js&"
export * from "./Attachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499a8808')) {
      api.createRecord('499a8808', component.options)
    } else {
      api.reload('499a8808', component.options)
    }
    module.hot.accept("./Attachments.vue?vue&type=template&id=499a8808&", function () {
      api.rerender('499a8808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Support/Common/Attachments.vue"
export default component.exports